module.exports = __webpack_public_path__ + "static/media/(V)_MG_5569_-_Cia_Termal_Beachewear_-_Moda_Feminina_-_Moda_Feminina_Infantil.267549c0.jpg";